import { root, id } from './customers';
import { trials } from './trials';

export const customers = {
  ...root,
  id: {
    ...id,
    trials,
  },
};
